export const FALLBACK_NAME = 'DevrimBey';
export const FALLBACK_LOGO = '/logo-devrimbey.png';

export function isPrimaryBrandHost(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const h = String(hostname || '').replace(/^www\./, '').toLowerCase();
  return h === 'localhost' || h === '127.0.0.1' || h === 'devrimbey.com';
}

export function revealTenantBoot() {
  try {
    document.documentElement.removeAttribute('data-boot');
  } catch { /* ignore */ }
}

export function hostLabel(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  return String(hostname || '').replace(/^www\./, '') || 'Panel';
}

export function displayBrandName(siteName, hostname) {
  const name = String(siteName || '').trim();
  if (name && name.toLowerCase() !== FALLBACK_NAME.toLowerCase()) return name;
  if (isPrimaryBrandHost(hostname)) return name || FALLBACK_NAME;
  return hostLabel(hostname);
}
